// extracted by mini-css-extract-plugin
export default {"button":"Styles_button__ujwnt","smallButton":"Styles_smallButton__6yxjc","prompt":"Styles_prompt__lEqM0"};